// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ExecutedClawback } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Model/MarkerEvents';
import { TemplateHistory, useTemplateHistory } from '../../useTemplateHistory';

const useExecutedClawbacks = (): TemplateHistory<ExecutedClawback> =>
  useTemplateHistory(ExecutedClawback);

export default useExecutedClawbacks;
